import { render } from "./orders_report.vue?vue&type=template&id=041da2ba&scoped=true"
import script from "./orders_report.vue?vue&type=script&lang=js"
export * from "./orders_report.vue?vue&type=script&lang=js"

import "./orders_report.vue?vue&type=style&index=0&id=041da2ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041da2ba"]])

export default __exports__